import React from 'react';
import Login from 'pages/Login';
import { Navigate } from 'react-router-dom';
import { ComplexRoute } from './components/Routes/Routes';
import AuthRouter from './subrouters/Auth/Auth.router';
import authRoutes from './subrouters/Auth/routes';
import DashboardRouter from './subrouters/Dashboard/Dashboard.router';
import dashRoutes from './subrouters/Dashboard/routes';
import ForgotPassword from 'pages/ForgotPassword';
import ResetPassword from 'pages/ResetPassword';
import VerifyEmail from 'pages/VerifyEmail';

export default [
  {
    path: 'login',
    authorized: false,
    element: Login,
    onlyPublic: true,
  },
  {
    path: 'forgot-password',
    authorized: false,
    element: ForgotPassword,
    onlyPublic: true,
  },
  {
    path: 'reset-password',
    authorized: false,
    element: ResetPassword,
    onlyPublic: true,
  },
  {
    path: 'verify-email',
    authorized: false,
    element: VerifyEmail,
  },
  {
    path: 'auth',
    element: AuthRouter,
    routes: authRoutes,
    authorized: true,
  },
  {
    path: 'dash',
    element: DashboardRouter,
    routes: dashRoutes,
    authorized: true,
  },
  {
    index: true,
    element: <Navigate to="dash" replace />,
  },
  {
    path: '*',
    element: () => `not found`,
  },
] as Array<ComplexRoute>;
